/**
 * Pure H OS · Phase D Wave 2 · Procurement (types + live view).
 * MongoDB collection: `pureh_procurement`.
 */
import { liveArray } from "../services/store";

export type PoStatus = "draft" | "pending" | "approved" | "received" | "closed";

export type PurchaseOrder = {
  id: string;
  poNumber: string;
  supplier: string;
  category: string;
  status: PoStatus;
  amountEGP: number;
  orderedRelative: string;
  expectedRelative: string;
  owner: string;
  linkedTo?: string | null;
};

export const PROCUREMENT: PurchaseOrder[] = liveArray<PurchaseOrder>("procurement");
